export default function messageOnGetUserInfo(status) {
    let message

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos obter os dados do usuário.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não conseguimos obter os dados do usuário. Por favor, tente novamente mais tarde.'
    }
    return message
}
